class ShopTheLook extends window.HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.slides = this.querySelectorAll('.slide');
        this.slides.forEach(slide => {
            const dotPoints = slide.querySelectorAll('[data-dot-point]');
            const productInfoBoxes = slide.querySelectorAll('[data-product-info-box]');
            
            dotPoints.forEach(dotPoint => {
                dotPoint.addEventListener('click', (event) => this.onDotPointClick(event, dotPoints, productInfoBoxes));
            });
        });
    }

    disconnectedCallback() {
        this.slides.forEach(slide => {
            const dotPoints = slide.querySelectorAll('[data-dot-point]');
            dotPoints.forEach(dotPoint => {
                dotPoint.removeEventListener('click', this.onDotPointClick);
            });
        });
    }

    onDotPointClick(event, dotPoints, productInfoBoxes) {
        const dot = event.currentTarget || event.target.closest('[data-dot-point]');
        if (!dot) return;
        const index = dot.getAttribute('data-dot-point');
        
        dotPoints.forEach(dotPoint => {
            dotPoint.classList.remove('active-dot-point');
        });
        productInfoBoxes.forEach(productInfoBox => {
            productInfoBox.classList.remove('show-product-info');
        });

        dot.classList.add('active-dot-point');
        const targetBox = this.querySelector(`[data-product-info-box="${index}"]`);
        if (targetBox) {
            targetBox.classList.add('show-product-info');
        }
    }
}

window.customElements.define("shop-the-look", ShopTheLook);